import { SxStyleProp } from 'theme-ui';

export const skeletonStyle: SxStyleProp = {
  borderRadius: 'alert',
  bg: 'grey2'
};

export const playBtnStyle: SxStyleProp = {
  all: 'unset',
  display: 'flex',
  flexWrap: 'wrap',
  position: 'relative',
  minWidth: 40,
  width: 40,
  height: 40,
  borderRadius: 'alert',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundSize: 'cover'
};
export const trackTitleStyle: SxStyleProp = {
  fontWeight: 'heading',
  fontSize: '12px'
};

export const trackTextStyle: SxStyleProp = {
  fontWeight: 'body',
  fontSize: '12px'
};

export const addBtnStyle: SxStyleProp = {
  all: 'unset',
  display: 'flex',
  width: 32,
  height: 32,
  padding: 0,
  border: '0',
  justifyContent: 'center'
};

export const tagButtonStyle = (active: boolean): SxStyleProp => ({
  px: '12px',
  py: '7px',
  mb: '4px',
  mr: '4px',
  borderRadius: '4px',
  borderStyle: 'solid',
  borderColor: '#DCDDE9',
  borderWidth: 1,
  justifyContent: 'center',
  bg: active ? '#282B36' : 'white',
  color: active ? 'white' : '#545869',
  fontSize: '12px',
  '&:hover': {
    bg: '#f8f8f8'
  }
});

export const audioTimeLineContainer: SxStyleProp = {
  mt: 4,
  px: 3,
  '.audioTimeline': {
    height: 2,
    bg: '#DCDDE9',
    '.sliderHandle': {
      top: '-3px !important',
      border: 'none',
      width: 8,
      height: 8,
      boxShadow: 'none'
    }
  }
};

export const songStyles: SxStyleProp = {
  pb: 6,
  '.song-container': { justifyContent: 'space-between', alignItems: 'center', display: 'flex' },
  '.song-button-play': playBtnStyle,
  '.song-button-play-overlay': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'rgba(40,43,54,0.2)',
    zIndex: 0
  },
  '.song-col-1': {
    display: 'flex',
    flexWrap: 'wrap'
  },
  '.song-col-2': {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    minWidth: 96
  },
  '.song-button-play-icon': {
    zIndex: 1
  },
  '.song-info': {
    ml: 4,
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 168
  },
  '.song-text': trackTitleStyle,
  '.song-artist-name': { ...trackTextStyle, color: 'grey3' },
  '.song-premium-icon': { width: 19, height: 19, display: 'block' },
  '.song-add-button': addBtnStyle
};
